import { settlementStatusMap } from "../../constants";
export function parseSettlementStatus(status) {
    return settlementStatusMap[status] || "Unknown";
}
export function parseSettlementStatusesByBonusesAndTags(settlementStatus, boostStatus, earlyExitStatus) {
    if (boostStatus === "GuaranteedPayoutWon") {
        return "GhostWin";
    }
    let status = earlyExitStatus === "Full" ? "EarlyExit" : settlementStatus;
    status = earlyExitStatus === "Applied" && settlementStatus === "Won" ? "EarlyExitWin" : status;
    return status;
}
export const getIsCashOutOrCancelled = (settlementStatus) => settlementStatus === "CashOut" || settlementStatus === "Cancelled";
//# sourceMappingURL=parseSettlementStatus.js.map